/**export const oidcSettings = {
  authority: 'https://portaldev.synelia.fr',
  clientId: 'TourneeAzoteSPALocal',
  redirectUri: `http://localhost:63532/signin-oidc`,
  responseType: 'id_token token',
  scope: 'openid profile'
}*/

export const oidcSettings = {
  authority: process.env.VUE_APP_AUTHORITY,
  clientId: process.env.VUE_APP_CLIENT_ID,
  redirectUri: process.env.VUE_APP_REDIRECT_URI,
  responseType: process.env.VUE_APP_RESPONSE_TYPE,
  scope: process.env.VUE_APP_SCOPE
}